export const HOME = '/';
export const SIGN_IN = '/signIn';
export const REPORTS = '/reports';
export const ADD_REPORT = '/addReport';
export const VIEW_REPORT = '/viewReport/:reportKey';
export const INTEGRATIONS = '/integrations';
